import { EpimsBaseEntityDto } from './epim-base.dto';
export class  CounselTypeDto extends EpimsBaseEntityDto {

    CounselTypeId: string;

    CounselTypeName: string;

   

}